import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import UserPermissionsList from "./userPermissionList";
import { fetchUserPermissionsList } from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";

const UserPermissions = ({ navigate }) => {
  const [userPermissionList, setUserPermissionList] = useState([]);
  const getData = async () => {
    const res = await fetchUserPermissionsList();
    if (res?.data?.success && res?.data?.data) {
      setUserPermissionList(res.data.data);
    } else {
      handleErrors(res, navigate);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>System Settings</a>
                  </li>
                  <li className="breadcrumb-item active text-light">
                    User Base Permission
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <UserPermissionsList
            listData={userPermissionList}
            getData={getData}
          />
        </div>
      </div>
    </DashboardLayout>
  );
};
export default UserPermissions;
